export enum RegainExportStatus {
  REQUESTED = "requested",
  PROCESSING = "processing",
  READY = "ready"
}

export type RegainExportReadyResponse = {
  status: RegainExportStatus.READY;
  downloadUrl: string;
};

export type RegainExportPendingResponse = {
  status: RegainExportStatus.PROCESSING | RegainExportStatus.REQUESTED;
};

export type GetRegainExportResponse = RegainExportReadyResponse | RegainExportPendingResponse;
